import React from 'react';
import { Container, Row, Col, Navbar } from 'react-bootstrap';
import { Outlet } from "react-router-dom";
import '../assets/css/useraccount.css';
import LoginLogo from '../assets/images/login-logo.png';
import { Link } from 'react-router-dom';

const UserAccount = () => {

    return (
        <>
            <div className="login_body">
                <Container fluid className="form_center shadow-lg">
                    <Row>
                        <Col xs="12" sm="6" md="6" lg="6" className="py-3 bg1 d-flex justify-content-center align-items-center">
                            <div className="text-center ">
                                <Navbar.Brand as={Link} to="/" className="mx-0 px-0">
                                    <img src={LoginLogo} alt="Transit Reward Portal" className="img-fluid mb-3" width="230" height="230" />
                                    {/* <h4 className="text-wrap text-white text-center fw-bold">Bela Life</h4> */}
                                </Navbar.Brand>
                            </div>
                        </Col>
                        <Col xs="12" sm="6" md="6" lg="6" className='d-scroll'>
                            <Outlet />
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
};

export default UserAccount;
